<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="11" lg="9">
        <v-card flat>
          <v-card-text class="pt-10">
            <v-form>
              <v-row dense justify="center">
                <v-col
                  cols="12"
                  md="10"
                  v-for="(item, index) in listForm"
                  :key="index"
                  class="pb-5"
                >
                  <div class="text-h6 text--primary">{{ item.label }}:</div>

                  <div v-if="['select'].includes(item.inputType)">
                    <!-- <select class="form-control form-control-sm">
                          <option
                            v-for="(option, index) in item.value"
                            :key="index"
                            >{{ option.name }}</option
                          >
                        </select> -->
                    <v-select
                      filled
                      rounded
                      class="rounded-small"
                      :items="item.value"
                      item-text="name"
                      item-value="value"
                      :label="item.placeholder"
                      :hint="item.hint != '' ? item.hint : ''"
                      :hide-details="item.hint != '' ? false : true"
                      v-model="listAnswer[index].response"
                    >
                    </v-select>
                  </div>
                  <div v-else-if="['radio'].includes(item.inputType)">
                    <v-radio-group v-model="listAnswer[index].response">
                      <v-radio
                        v-for="(option, index) of item.value"
                        :key="index"
                        :label="option.name"
                        :value="option.value"
                      ></v-radio>
                      <!-- <input
                              :type="item.inputType"
                              :id="'Option-' + index"
                              :name="item.name + '-options'"
                              class=" col-1 form-check-input"
                              disabled
                            /> -->
                    </v-radio-group>
                  </div>
                  <div v-else-if="['checkbox'].includes(item.inputType)">
                    <v-checkbox
                      v-model="checkbox"
                      :label="`Checkbox 1: ${checkbox.toString()}`"
                    ></v-checkbox>
                    <v-radio
                      v-for="(option, index) of item.value"
                      :key="index"
                      :label="option.name"
                      :value="option.value"
                    ></v-radio>
                    <!-- <input
                              :type="item.inputType"
                              :id="'Option-' + index"
                              :name="item.name + '-options'"
                              class=" col-1 form-check-input"
                              disabled
                            /> -->
                  </div>
                  <div v-else class="text-left">
                    <v-text-field
                      filled
                      rounded
                      full-width
                      class="rounded-small"
                      persistent-hint
                      :required="item.required === 1 ? true : false"
                      :type="item.inputType"
                      :label="item.placeholder"
                      :hint="item.hint != '' ? item.hint : ''"
                      :hide-details="item.hint != '' ? false : true"
                      v-model="listAnswer[index].response"
                    ></v-text-field>
                  </div>

                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions class="px-lg-8 pb-6">
            <!-- <v-row align="center" justify="end">
                       
                        
                      </v-row> -->
            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                large
                :loading="isLoading"
                :disabled="isLoading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8 mx-auto"
                @click="submitForm"
                >Guardar respuestas</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- {{ listAnswer }} -->
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  created() {
    this.getSurvey();
  },

  data() {
    return {
      isLoading: false,
      listAnswer: [],
      listForm: [],
      icons: {
        text: "fas fa-font",
        email: "fas fa-at",
        number: "fas fa-hashtag",
        date: "far fa-calendar-check",
        checkbox: "far fa-check-square",
        "checkbox-group": "fas fas-check-square",
        radio: "far fa-check-circle",
        select: "fas fa-bars",
      },
    };
  },

  // watch: {
  //   listForm: {
  //     // handler() {},
  //     deep: true,
  //   },
  // },

  methods: {
    async getSurvey() {
      this.isLoading = true;

      const payload = this.$route.params.surveyID;

      await PbxHttpClient.get(`/surveys/survey/${payload}`)
        .then((res) => {
          this.listForm = res.data.question;

          // String to JSON
          this.listForm.forEach((item) => {
            if (["radio", "select", "checkbox"].includes(item.inputType)) {
              item.value = JSON.parse(item.value);
            }
          });

          // Add value input
          this.listForm.forEach((item) => {
            // item.answer = null;
            this.listAnswer.push({
              question_survey_id: item.id,
              response: null,
            });
          });
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async submitForm() {
      this.isLoading = true;

      try {
        const id = this.$route.params.userID;
        const payload = { data: this.listAnswer };

        const { data } = await PbxHttpClient.post(
          `/surveys/response_question/${id}`,
          payload
        );

        this.$snotify.success(`Encuesta respondida con éxito.`);

        this.$router.push({ name: "Formularios" });
      } catch (err) {
        this.$snotify.error(err.response?.data?.error, "¡Error!");
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
